import axios from "@/axiosMeth";

async function userDefaultList(data) {
    return await axios.requestApiGet('request/text/user', data);
}

async function userDeleteListItem(id) {
    return await axios.requestApiDelete(`request/text/user/${id}`);
}

async function userStoreItem(data) {
    return await axios.requestApiPost('request/text/user', data);
}

async function userUpdateItem(id, data) {
    return await axios.requestApiPut('request/text/user/'+id, data);
}

async function adminDefaultList(data) {
    return await axios.requestApiGet('request/text/admin', data);
}

async function adminGenerateDefaultList(id,data) {
    return await axios.requestApiPost(`request/text/admin/${id}/generate`, data);
}

async function adminRejectDefaultList(id,data) {
    return await axios.requestApiDelete(`request/text/admin/${id}`, data);
}

export {
    userDefaultList,
    userDeleteListItem,
    userStoreItem,
    userUpdateItem,
    adminDefaultList,
    adminGenerateDefaultList,
    adminRejectDefaultList
}